export default __webpack_public_path__ + "static/media/LOGO.286a51ba.png";